<div>
  <div>
    <mat-form-field class="example-chip-list example-full-width" [appearance]="appearance">
      <mat-chip-list #chipList aria-label="Categorys">
        <mat-chip
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="3"
          *ngFor="let category of categoryList"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(category)"
        >
          {{ getCategoryDescription(category) }}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <mat-label *ngIf="!this.readOnly"> Categories </mat-label>

      <input
        [disabled]="isReadOnly"
        *ngIf="!this.readOnly"
        #categoryInput
        (ngModelChange)="categoryInputChanged($event)"
        [(ngModel)]="categoryValue"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="add($event)"
      />

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let category of filteredCategorys | async" [value]="category">
          <span>{{ getCategoryDescription(category) }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</div>
